export default __webpack_public_path__ + "static/media/CometChatUI.84b12b0b.png";